import { Syllabus } from '@/kontent/content-types'
import WpResources from '@/layouts/wp_resources'
import { SYLLABUS_TABS } from '@/legacy-ported/constants'
import { CommonContentTab } from '@/pages/learning-areas/[learningarea]/[syllabus]/[tab]'
import { CommonPageProps, TaxoStageWithLifeSkill } from '@/types'
import { DownloadListAzureField } from '@/types/downloadListAzureData'
import { byTaxoCodename } from '@/utils'
import { isStage6Syllabus } from '@/utils/syllabus'
import clsx from 'clsx'
import { Fragment, useCallback, useMemo } from 'react'

const teachingAndLearningTab = SYLLABUS_TABS.find(
	(tab) => tab.id === 'teaching-and-learning',
)

export const TeachingLearning = ({
	data,
	mappings,
	preview,
	isUseWrapper = true,
}: CommonPageProps<Syllabus, CommonContentTab<Syllabus>> & {
	isUseWrapper?: boolean
}) => {
	const { syllabus: syllabusResponse, stages: allStages } = data
	const syllabus = syllabusResponse.item
	const currentStages: TaxoStageWithLifeSkill[] =
		syllabus.elements.stages__stages.value.map(byTaxoCodename)
	// current taxo term of taxo stages
	const currentTaxoTermStages = allStages.filter((s) =>
		currentStages.includes(s.codename),
	)

	// Computed
	const taxoSyllabusCodenamesOfCurrentSyllabus = useMemo(() => {
		return syllabus.elements.syllabus.value.map((t) => t.codename)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [syllabus.system.codename])

	const calculateHiddenColumns = useCallback(
		(
			isFilterShown: boolean,
			isScreenDownLg: boolean,
		): DownloadListAzureField[] => {
			const defaultHiddens: DownloadListAzureField[] = [
				'fileType',
				'year',
				'fileSize',
				'syllabuses',
			]
			if (isScreenDownLg) {
				return [
					...defaultHiddens,
					'syllabuses',
					'resource_type',
					'stages',
					'officialreleasedate',
				]
			}

			return isFilterShown
				? [...defaultHiddens, 'resource_type', 'stages']
				: [...defaultHiddens, 'info']
		},
		[],
	)

	const _isStage6Syllabus = useMemo(() => {
		return isStage6Syllabus(syllabus)
	}, [syllabus])

	const Tag = isUseWrapper ? 'div' : Fragment

	return (
		<Tag className={clsx({ 'px-4 pt-8': isUseWrapper })}>
			<WpResources
				preview={preview}
				mappings={mappings}
				data={
					{
						...data,
						pageResponse: {
							...data.pageResponse,
							item: {
								elements: {
									title: {
										value: teachingAndLearningTab.name,
									},
								},
								system: {
									id: undefined,
								},
							},
						},
					} as any
				}
				previewData={false}
				defaultFilterShown={true}
				preSelectedSyllabuses={taxoSyllabusCodenamesOfCurrentSyllabus}
				includeStages={currentTaxoTermStages.map(byTaxoCodename)}
				getHiddenColumns={calculateHiddenColumns}
				hideSyllabusFilter
				hideStageGroupsInStageFilter
				hideStageFilter={_isStage6Syllabus}
				showYearFilter={_isStage6Syllabus}
				titleTag="h2"
				pageType="Syllabus support tab"
				hideFilterQuery={true}
				useLearningSupportApi={true}
			/>
		</Tag>
	)
}

export default TeachingLearning
